import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import sessionUtils from '../../../../utilities/SessionHandler'
import ModalComponent from '../../../../components/Private/ModalComponent'
import categoryGroupService from '../../../../services/categorygroups'
import categoryService from '../../../../services/categories'
import tagService from '../../../../services/tags'
import applicationService from '../../../../services/applications'
import companyService from '../../../../services/companies'
import fileService from '../../../../services/files'
import applicationFileService from '../../../../services/applicationFiles'
import applicationCategoryGroupService from '../../../../services/applicationCategoryGroups'

export default function Index(
  {
    contestData,
    formTitle,
    backRoute,
    itemData = null,
    readOnly = false,
    assignableUser = false
  }
) {

  const navigateTo = useNavigate()
  let credentials = sessionUtils.getParsedCredentials()
  const textareaRef = useRef()

  const [showPreOperationModal, setShowPreOperationModal] = useState(false)
  const [preOperationModalTitle, setPreOperationModalTitle] = useState('Confirmación')
  const [preOperationModalMessage, setPreOperationModalMessage] = useState('¿Está seguro de querer guardar y enviar?')

  const [newBackRoute, setNewBackRoute] = useState(backRoute)
  const [callbackData, setCallbackData] = useState(null)
  const [showSaveModal, setShowSaveModal] = useState(false)
  const [saveModalTitle, setSaveModalTitle] = useState('Éxito')
  const [showSaveAndSendModal, setShowSaveAndSendModal] = useState(false)
  const [saveAndSendModalTitle, setSaveAndSendModalTitle] = useState('Éxito')

  const [showGenericModal, setShowGenericModal] = useState(false)
  const [genericModalTitle, setGenericModalTitle] = useState('Operación completada')
  const [genericModalMessage, setGenericModalMessage] = useState('')

  const [showGenericActionModal, setShowGenericActionModal] = useState(false)
  const [genericActionModalTitle, setGenericActionModalTitle] = useState('Operación completada')
  const [genericActionModalButton, setGenericActionModalButton] = useState('')
  const [genericActionModalMessage, setGenericActionModalMessage] = useState('')

  const [formUserId, setFormUserId] = useState(null)

  const [dynamicFormList, setDynamicFormList] = useState([])
  const [formData, setFormData] = useState({
    applicationBranch: itemData?.applicationBranch || '',
    applicationTitle: itemData?.applicationTitle || '',
    applicationDescription: itemData?.applicationDescription || '',
    applicationBenefits: itemData?.applicationBenefits || '',
    applicationImplementationDate: itemData?.applicationImplementationDate || '',
    applicationAdminNotes: itemData?.applicationAdminNotes || '',
    applicationAdminScore: itemData?.applicationAdminScore != 0 ? itemData?.applicationAdminScore : 1,
    files: itemData.files || [],
    dynamic: itemData.dynamic || [],
  })

  const [companyData, setCompanyData] = useState([])

  const handleCompanyLoad = async () => {
    const result = await companyService.get(itemData?.company_id)
    if (formData.applicationBranch === '') {
      setFormData({
        ...formData,
        applicationBranch: result.companyBranchName
      })
    }
    setCompanyData(result)
  }

  const getDynamicCategory = (categoryGroupId) => {
    return formData.dynamic.find(dynamic => dynamic.categoryGroupId === categoryGroupId)?.category
  }

  const getCategoryById = (categoryGroupId, categoryId) => {
    if (!categoryId) return null
    return dynamicFormList.find(cg => cg.id === categoryGroupId)?.categories.find(c => c.id === categoryId)
  }

  const handleCategoryLoad = async () => {
    const result = await categoryGroupService.byContest(contestData.id)
    setDynamicFormList(result)
    let dynamic = []
    result.forEach(async (categoryGroup, indexCG) => {
      dynamic.push({
        categoryGroupId: categoryGroup.id,
        category: {}
      })
    })
    if (itemData?.dynamic) {
      itemData.dynamic.forEach((item) => {
        const dynamicIndex = dynamic.findIndex((item2) => item2.categoryGroupId === item.categoryGroupId)
        if (dynamicIndex !== -1) {
          dynamic[dynamicIndex] = item
        }
      })
    }
    setFormData({
      ...formData,
      dynamic: dynamic
    })
  }

  const handleFormChange = (event) => {

    const { name, value } = event.target
    const inputData = event.target.getAttribute('input-data')
    const inputTarget = event.target.getAttribute('input-target')
    const categoryGroupId = event.target.getAttribute('category-group-id')

    if (inputData === 'static') {
      setFormData({
        ...formData,
        [name]: value
      })
    } else if (inputData === 'score') {
      // 1. If user backspaces (value is empty), update state to empty
      if (value === "") {
        setFormData({ ...formData, [name]: "" });
        return;
      }

      // 2. Get only the LAST character entered (the "newest" input)
      const lastChar = value.slice(-1);
      const numValue = parseInt(lastChar, 10);
      const allowedValues = [1, 3, 5, 7];

      // 3. If the last character is valid, replace the entire field with it
      if (allowedValues.includes(numValue)) {
        setFormData({
          ...formData,
          [name]: lastChar // This effectively "replaces" the old value
        });
      }
      // Note: If they type an invalid number (like 2 or 8), 
      // we do nothing, which keeps the old valid value in the box.
    }
    else if (inputData === 'dynamic') {
      if (inputTarget === 'categories') {
        const dynamicIndex = formData.dynamic.findIndex((item) => item.categoryGroupId === categoryGroupId)
        const dynamicCopy = [...formData.dynamic]
        if (dynamicCopy.length > 0) {
          dynamicCopy[dynamicIndex].category = {
            categoryId: value,
            tags: []
          }
        } else {
          dynamicCopy.push({
            categoryGroupId: categoryGroupId,
            category: {
              categoryId: value,
              tags: []
            }
          })
        }
        setFormData({
          ...formData,
          dynamic: dynamicCopy
        })
      } else if (inputTarget === 'tags') {
        const dynamicIndex = formData.dynamic.findIndex((item) => item.categoryGroupId === categoryGroupId)
        if (dynamicIndex === -1 || !formData.dynamic[dynamicIndex].category) return
        const dynamicCopy = [...formData.dynamic]
        const categoryIndex = dynamicCopy[dynamicIndex].category.tags.findIndex((item) => item === value)

        const categoryGroup = dynamicFormList.find((item) => item.id === categoryGroupId)
        if (!categoryGroup) return
        const category = categoryGroup.categories.find((item) => item.id === dynamicCopy[dynamicIndex].category.categoryId)
        if (!category) return
        const categoryType = category.categoryType

        if (categoryType === 'multiple') {
          if (categoryIndex === -1) {
            dynamicCopy[dynamicIndex].category.tags.push(value)
          } else {
            dynamicCopy[dynamicIndex].category.tags.splice(categoryIndex, 1)
          }
        } else {
          dynamicCopy[dynamicIndex].category.tags = [value]
        }

        setFormData({
          ...formData,
          dynamic: dynamicCopy
        })
      }
    }
  }

  const handleFormSaveAsSystem = async () => {
    let newFormData = {
      ...formData
    }
    await applicationService.update(itemData.id, newFormData)
    await applicationCategoryGroupService.create({
      application_id: itemData.id,
      categoryGroups: formData.dynamic
    })
    setShowSaveModal(true)
  }

  const handleFormSave = async () => {
    let newFormData = {
      ...formData,
      applicationStatusDraft: "Devuelta",
      applicationStatusAfterDraft: "En revisión",
      applicationStatusEditedByAdmin: "Editada",
      applicationStatusReturnMotive: "",
      applicationStatusRejectMotive: "",
    }
    await applicationService.update(itemData.id, newFormData)
    setShowSaveModal(true)
  }

  const handleFormSaveAndSend = async () => {
    let newFormData = {
      ...formData,
      applicationStatusDraft: "Enviada",
      applicationStatusAfterDraft: "En revisión",
      applicationStatusEditedByAdmin: "Editada",
      applicationStatusReturnMotive: "",
      applicationStatusRejectMotive: "",
    }
    await applicationService.update(itemData.id, newFormData)
    setCallbackData({ destination: "/applications/enviadas" })
    setShowSaveAndSendModal(true)
  }

  const handleCallbackOnHide = (data) => {
    navigateTo(data.destination)
  }

  const handleFileUpload = async (event) => {

    try {
      if (event.target.files.length > 0) {
        let fileName = event.target.files[0].name

        const newFile = await fileService.create({
          file: event.target.files[0],
        })

        if (newFile?.error === true) {
          alert("Error al subir el archivo: " + newFile.message)
          return
        }

        let newApplicationFile = await applicationFileService.create({
          application_id: itemData.id,
          applicationFileName: fileName,
          file_id: newFile.id
        })
        let newFiles = [...formData.files]
        newFiles.push(newApplicationFile)
        setFormData({
          ...formData,
          files: newFiles
        })
      }
    } catch (error) {
      alert("Error al subir el archivo")
    }
  }

  const handleFileDownload = async (item) => {
    const fileResult = await fileService.get(item.file_id)
    console.log(fileResult)
    if (!fileResult || !fileResult.fileBase64) {
      if (fileResult.fileMimeType === "application/x-empty") {
        return alert("El archivo no existe, está vacío o corrupto")
      } else
        return alert(fileResult.fileErrorMessage)
    }
    const linkSource = `data:${fileResult.fileMimeType};base64,${fileResult.fileBase64}`
    const downloadLink = document.createElement("a")
    const fileName = item.applicationFileName
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }

  const handleFileDelete = async (item) => {
    await applicationFileService.remove(item.id)
    let newFiles = [...formData.files]
    newFiles.splice(newFiles.findIndex((file) => file.id === item.id), 1)
    setFormData({
      ...formData,
      files: newFiles
    })
  }

  const handleSetApplicationUser = async () => {
    await applicationService.patch(itemData.id, {
      user_id: credentials.id
    })
    setFormUserId(credentials.id)
  }

  const handleUnsetApplicationUser = async () => {
    await applicationService.patch(itemData.id, {
      user_id: null
    })
    setFormUserId(null)
  }

  const handleApplicationAfterDraftReturn = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusDraft: "Devuelta",
      applicationStatusAfterDraft: "En revisión",
      applicationStatusReturnMotive: textareaRef.current.value,
      applicationStatusRejectMotive: "",
    })
    setCallbackData({ destination: "/applications/enviadas" })
    setGenericModalMessage("La postulación ha sido devuelta al postulante")
    setShowGenericModal(true)
    textareaRef.current.value = ""
  }

  const handleApplicationAfterDraftApprove = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusAfterDraft: "Aprobada",
      applicationStatusPreselection: "En revisión",
      applicationStatusReturnMotive: "",
      applicationStatusRejectMotive: "",
    })
    setCallbackData({ destination: "/applications/enviadas" })
    setGenericModalMessage("La postulación ha sido aprobada")
    setShowGenericModal(true)
  }

  const handleApplicationAfterDraftReject = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusAfterDraft: "Rechazada",
      applicationStatusPreselection: "",
      applicationStatusRejectMotive: textareaRef.current.value,
      applicationStatusReturnMotive: "",
    })
    setCallbackData({ destination: "/applications/enviadas" })
    setGenericModalMessage("La postulación ha sido rechazada")
    setShowGenericModal(true)
    textareaRef.current.value = ""
  }

  const handleApplicationPreselectionApprove = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusPreselection: "Seleccionada",
      applicationStatusFinalist: "En revisión",
      applicationStatusReturnMotive: "",
      applicationStatusRejectMotive: "",
    })
    setCallbackData({ destination: "/applications/preseleccion" })
    setGenericModalMessage("La postulación ha sido seleccionada")
    setShowGenericModal(true)
  }

  const handleApplicationPreselectionReject = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusPreselection: "No seleccionada",
      applicationStatusRejectMotive: textareaRef.current.value,
      applicationStatusReturnMotive: "",
    })
    setCallbackData({ destination: "/applications/preseleccion" })
    setGenericModalMessage("La postulación ha sido marcada como no seleccionada")
    setShowGenericModal(true)
    textareaRef.current.value = ""
  }

  const handleApplicationFinalistApprove = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusFinalist: "Seleccionada",
      applicationStatusFinal: "No destacada",
      applicationStatusReturnMotive: "",
      applicationStatusRejectMotive: "",
    })
    setCallbackData({ destination: "/applications/finalistas" })
    setGenericModalMessage("La postulación ha sido seleccionada")
    setShowGenericModal(true)
  }

  const handleApplicationFinalistReject = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusFinalist: "No seleccionada",
      applicationStatusRejectMotive: textareaRef.current.value,
      applicationStatusReturnMotive: "",
    })
    setCallbackData({ destination: "/applications/finalistas" })
    setGenericModalMessage("La postulación ha sido marcada como no seleccionada")
    setShowGenericModal(true)
    textareaRef.current.value = ""
  }

  const handleApplicationFinalWinner = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusFinal: "Ganadora",
      applicationStatusReturnMotive: "",
      applicationStatusRejectMotive: "",
    })
    setCallbackData({ destination: "/applications/destacadas" })
    setGenericModalMessage("La postulación ha sido marcada como ganadora")
    setShowGenericModal(true)
  }

  const handleApplicationFinalFeature = async () => {
    await applicationService.patch(itemData.id, {
      applicationStatusFinal: "Destacada",
      applicationStatusReturnMotive: "",
      applicationStatusRejectMotive: "",
    })
    setCallbackData({ destination: "/applications/destacadas" })
    setGenericModalMessage("La postulación ha sido marcada como destacada")
    setShowGenericModal(true)
  }

  useEffect(() => {
    const loadData = async () => {
      await handleCategoryLoad()
      await handleCompanyLoad()
    }
    loadData()
  }, [])

  useEffect(() => {

  }, [])

  useEffect(() => {
    if (itemData) {
      setFormData({
        ...formData,
        applicationImplementationDate: itemData.applicationImplementationDate,
        applicationTitle: itemData.applicationTitle,
        applicationDescription: itemData.applicationDescription,
        applicationBenefits: itemData.applicationBenefits,
      })
      setFormUserId(itemData.user_id)

      if (itemData.applicationStatusFinal !== '') {
        setNewBackRoute('/applications/destacadas')
      }
      else if (itemData.applicationStatusFinalist !== '') {
        setNewBackRoute('/applications/finalistas')
      }
      else if (itemData.applicationStatusPreselection !== '') {
        setNewBackRoute('/applications/preseleccion')
      }
      else if (itemData.applicationStatusAfterDraft !== '') {
        setNewBackRoute('/applications/enviadas')
      }

    }
  }, [])

  useEffect(() => {
    //console.log(dynamicFormList)
  }, [dynamicFormList])

  useEffect(() => {
    //console.log(formData)
  }, [formData])

  return (
    <>
      <main className="theme-light">
        <div className="container">
          <div className="row mb-4">
            {
              itemData.applicationStatusRejectMotive &&
              <div className="col-md-12 order-2 order-lg-1 d-flex align-items-center justify-content-between">
                <div className="alert alert-danger w-100" role="alert">
                  <strong>Motivo de rechazo: </strong>{itemData.applicationStatusRejectMotive}
                </div>
              </div>
            }
            {
              itemData.applicationStatusReturnMotive &&
              <div className="col-md-12 order-2 order-lg-1 d-flex align-items-center justify-content-between">
                <div className="alert alert-warning w-100" role="alert">
                  <strong>Motivo de devolución: </strong>{itemData.applicationStatusReturnMotive}
                </div>
              </div>
            }
            <div className="col-md-7 order-2 order-lg-1 d-flex align-items-center justify-content-between">
              <h2 className="page-title fw-bold mb-0">
                <div className='d-flex justify-content-start'>
                  {
                    <div className="btn-group mt-lg-0 mt-4 me-3">
                      <button className="btn btn-outline-primary px-3 py-2" type="button" onClick={
                        () => {
                          navigateTo(newBackRoute)
                        }
                      }>
                        <i className="fas fa-arrow-left"></i>
                      </button>
                    </div>
                  }
                  <h3 className="page-title fw-bold mb-lg-0 mb-4">
                    {formTitle}
                  </h3>
                </div>
              </h2>
            </div>
            <div className="col-md-5 order-1 order-lg-2 d-flex">
              <div className="ms-auto mb-lg-0 mb-3">
                {
                  assignableUser && formUserId && <>
                    <button
                      className="btn btn-outline-danger px-3 py-2 ms-4"
                      type="button"
                      onClick={
                        () => {
                          handleUnsetApplicationUser()
                        }
                      }
                    >
                      Liberar Postulación
                    </button>
                  </>
                }
                {
                  assignableUser && !formUserId && <>
                    <button
                      className="btn btn-primary px-3 py-2 ms-4"
                      type="button"
                      onClick={
                        () => {
                          handleSetApplicationUser()
                        }
                      }
                    >
                      Tomar Postulación
                    </button>
                  </>
                }
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card bg-fondo-suave">
                <div className="card-body p-4">
                  <form action="">
                    <div className="row">
                      <div className="col-md-6 px-md-4 px-0">
                        <div className="form-outline mb-4">
                          <label className="form-label" htmlFor="">Sede de la postulación</label>
                          <input
                            type="text"
                            className="form-control form-control-lg rounded-pill"
                            placeholder="Nombre de la Sede (Ej. Sede Principal)"
                            input-data={`static`}
                            id="applicationBranch"
                            name="applicationBranch"
                            value={formData.applicationBranch}
                            onChange={handleFormChange}
                            disabled={true}
                          />
                        </div>
                        <div className="form-outline mb-4">
                          <label className="form-label" htmlFor="">Título de la Buena Práctica</label>
                          <input
                            type="text"
                            className="form-control form-control-lg rounded-pill"
                            placeholder="Título de la Buena Práctica"
                            input-data={`static`}
                            id="applicationTitle"
                            name="applicationTitle"
                            value={formData.applicationTitle}
                            onChange={handleFormChange}
                            disabled={readOnly}
                          />
                        </div>
                        <div className="form-outline mb-4">
                          <label className="form-label" htmlFor="">Descripción</label>
                          <textarea
                            cols="30"
                            rows="5"
                            className="form-control form-control-lg"
                            placeholder="Describe los benefios de la buena práctica aplicada"
                            input-data={`static`}
                            id="applicationDescription"
                            name="applicationDescription"
                            value={formData.applicationDescription}
                            onChange={handleFormChange}
                            disabled={readOnly}
                          >
                          </textarea>
                        </div>
                        <div className="form-outline mb-4">
                          <label className="form-label" htmlFor="">Fecha de Implementación</label>
                          <input
                            type="date"
                            className="form-control form-control-lg rounded-pill"
                            placeholder=""
                            input-data={`static`}
                            id="applicationImplementationDate"
                            name="applicationImplementationDate"
                            value={formData.applicationImplementationDate || ''}
                            onChange={handleFormChange}
                            disabled={readOnly}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 px-md-4 px-0">
                        <div className="form-outline mb-4">
                          <label className="form-label" htmlFor="">Beneficios</label>
                          <textarea cols="30"
                            rows="5"
                            className="form-control form-control-lg"
                            placeholder="Describe los benefios de la buena práctica aplicada"
                            input-data={`static`}
                            id="applicationBenefits"
                            name="applicationBenefits"
                            value={formData.applicationBenefits}
                            onChange={handleFormChange}
                            disabled={readOnly}
                          >
                          </textarea>
                        </div>
                        <div className="form-outline mb-4">
                          <label className="form-label" htmlFor="">Antecedentes complementarios</label>
                          {
                            !readOnly && <div className="input-group mb-3">
                              <input
                                type="file"
                                className="form-control form-control-lg rounded-pill"
                                id="applicationFile"
                                name="applicationFile"
                                accept='.pdf, .doc, .docx, .xls, .xlsx, .jpg, .jpeg, .png, .gif'
                                value={``}
                                onChange={handleFileUpload}
                                disabled={readOnly}
                              />
                            </div>
                          }
                        </div>

                        <div className="form-outline mb-4">
                          {
                            formData.files.length > 0 &&

                            formData.files.map((item, index) => {
                              return (
                                <div className="mb-3" key={index}>
                                  <div className='d-flex justify-content-start align-items-center'>
                                    {
                                      !readOnly && <a
                                        onClick={
                                          () => handleFileDelete(item)
                                        }
                                        className='react-link btn btn-outline-danger me-4'
                                      >
                                        <i className="bi bi-trash"></i>
                                      </a>
                                    }
                                    <a
                                      onClick={
                                        () => handleFileDownload(item)
                                      }
                                      className="react-link"
                                    >
                                      {item.applicationFileName}
                                    </a>
                                  </div>
                                </div>
                              )
                            }
                            )
                          }
                          {
                            formData.files.length === 0 && <div className="mb-3">
                              <div className='d-flex justify-content-start align-items-center'>
                                <strong className="react-link text-danger">No hay archivos adjuntos</strong>
                              </div>
                            </div>
                          }
                        </div>


                      </div>
                    </div>
                    {

                      <div className="row">
                        {
                          dynamicFormList.length > 0 && dynamicFormList.map((categoryGroup, indexCG) => {
                            return (
                              <div className="col-md-6 px-md-4 px-0" key={indexCG}>
                                <div className="form-outline mb-2">
                                  <label className="form-label" htmlFor="">{categoryGroup.categoryGroupName}</label>
                                  <select
                                    disabled={readOnly}
                                    className="form-select form-select-lg"
                                    id={`categoryGroup${categoryGroup.id}-category`}
                                    name={`categoryGroup${categoryGroup.id}-category`}
                                    input-data={`dynamic`}
                                    input-target={`categories`}
                                    category-group-id={categoryGroup.id}
                                    value={
                                      getDynamicCategory(categoryGroup.id)?.categoryId
                                    }
                                    onChange={handleFormChange}
                                  >
                                    <option value="">Seleccione una opción</option>
                                    {
                                      categoryGroup.categories.map((category, indexC) => {
                                        return (
                                          <option
                                            value={category.id}
                                            key={indexC}
                                            category-group-id={categoryGroup.id}
                                            category-id={category.id}
                                          >
                                            {category.categoryName}
                                          </option>
                                        )
                                      })
                                    }
                                  </select>
                                </div>
                                {
                                  getDynamicCategory(categoryGroup.id)?.categoryId &&
                                  <div className="form-outline mb-4">
                                    {
                                      getCategoryById(categoryGroup.id, getDynamicCategory(categoryGroup.id)?.categoryId)?.categoryType === 'multiple' && <div>
                                        <p className='text-helper text-primary text-start'>Puedes elegir múltiples opciones</p>
                                      </div>
                                    }
                                    {
                                      getCategoryById(categoryGroup.id, getDynamicCategory(categoryGroup.id)?.categoryId)?.categoryType === 'simple' && <div>
                                        <p className='text-helper text-primary text-start'>Puedes elegir una opción</p>
                                      </div>
                                    }
                                    {
                                      (() => {
                                        const cat = getCategoryById(categoryGroup.id, getDynamicCategory(categoryGroup.id)?.categoryId)
                                        return cat?.categoryType === 'multiple' && cat?.tags?.map((tag, indexT) => {
                                          return (
                                            <div className="form-check" key={indexT}>
                                              <input
                                                disabled={readOnly}
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`categoryGroup${categoryGroup.id}-tag${tag.id}`}
                                                name={`categoryGroup${categoryGroup.id}-tag${tag.id}`}
                                                value={tag.id}
                                                category-group-id={categoryGroup.id}
                                                category-id={getDynamicCategory(categoryGroup.id)?.categoryId}
                                                onChange={handleFormChange}
                                                input-data={`dynamic`}
                                                input-target={`tags`}
                                                checked={
                                                  getDynamicCategory(categoryGroup.id)?.tags?.includes(tag.id)
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor={`categoryGroup${categoryGroup.id}-tag${tag.id}`}
                                              >
                                                {tag.tagName}
                                              </label>
                                            </div>
                                          )
                                        })
                                      })()
                                    }
                                    {
                                      (() => {
                                        const cat = getCategoryById(categoryGroup.id, getDynamicCategory(categoryGroup.id)?.categoryId)
                                        return cat?.categoryType === 'simple' && cat?.tags?.map((tag, indexT) => {
                                          return (
                                            <div className="form-check" key={indexT}>
                                              <input
                                                disabled={readOnly}
                                                className="form-check-input"
                                                type="radio"
                                                name={`categoryGroup${categoryGroup.id}-tag`}
                                                id={`categoryGroup${categoryGroup.id}-tag${tag.id}`}
                                                value={tag.id}
                                                category-group-id={categoryGroup.id}
                                                category-id={getDynamicCategory(categoryGroup.id)?.categoryId}
                                                onChange={handleFormChange}
                                                input-data={`dynamic`}
                                                input-target={`tags`}
                                                checked={
                                                  getDynamicCategory(categoryGroup.id)?.tags?.includes(tag.id)
                                                }
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor={`categoryGroup${categoryGroup.id}-tag${tag.id}`}
                                              >
                                                {tag.tagName}
                                              </label>
                                            </div>
                                          )
                                        })
                                      })()
                                    }
                                  </div>
                                }
                              </div>
                            )
                          })
                        }
                        {
                          credentials.role_id == 1 ? (
                            <div className="col-md-6 px-md-4 px-0">
                              <div className="form-outline mb-4">
                                <label className="form-label" htmlFor="">Observaciones Administrativas</label>
                                <textarea cols="30"
                                  rows="5"
                                  className="form-control form-control-lg"
                                  placeholder="Observaciones administrativas"
                                  input-data={`static`}
                                  id="applicationAdminNotes"
                                  name="applicationAdminNotes"
                                  value={formData.applicationAdminNotes}
                                  onChange={handleFormChange}
                                >
                                </textarea>
                              </div>

                              <div className="form-outline mb-4">
                                <label className="form-label" htmlFor="">
                                  Puntaje Administrativo
                                  <p className='form-text'>
                                    (1, 3, 5 o 7)
                                  </p>
                                </label>
                                <input
                                  type='number'
                                  className="form-control rounded-pill"
                                  inputMode='numeric'
                                  placeholder="Puntaje Administrativo"
                                  input-data={`score`}
                                  id="applicationAdminScore"
                                  name="applicationAdminScore"
                                  value={formData.applicationAdminScore}
                                  onChange={handleFormChange}
                                  style={
                                    {
                                      fontSize: 48,
                                      textAlign: 'center'
                                    }
                                  }
                                  min={1}
                                  max={7}
                                  step={2}
                                />
                              </div>
                            </div>
                          ) : (
                            <>
                              <input type='hidden' name='applicationAdminNotes' value={
                                formData.applicationAdminNotes
                              } />
                              <input type='hidden' name='applicationAdminScore' value={
                                formData.applicationAdminScore
                              } />
                            </>
                          )
                        }
                      </div>
                    }
                    <div className="d-flex justify-content-end">
                      {
                        <button
                          className="btn btn-outline-primary px-3 py-2 me-2"
                          type="button"
                          onClick={handleFormSaveAsSystem}
                        >
                          Guardar cambios
                        </button>
                      }
                    </div>
                    {
                      readOnly
                      && formUserId
                      && itemData.applicationStatusDraft === 'Enviada'
                      && itemData.applicationStatusAfterDraft === 'En revisión'
                      &&
                      <div className="d-flex justify-content-start">
                        <button
                          className="btn btn-warning px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            setGenericActionModalTitle('Escribe un mensaje')
                            setGenericActionModalMessage('Escribe aquí un mensaje')
                            setGenericActionModalButton(
                              <>
                                <button
                                  className="btn btn-warning px-3 py-2 me-2"
                                  type="button"
                                  onClick={async () => {
                                    handleApplicationAfterDraftReturn()
                                    setShowGenericActionModal(false)
                                  }}
                                >
                                  Enviar motivo de DEVOLUCIÓN
                                </button>
                              </>
                            )
                            setShowGenericActionModal(true)
                          }}
                        >
                          Devolver Postulación
                        </button>
                        <button
                          className="btn btn-danger px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            setGenericActionModalTitle('Escribe un mensaje')
                            setGenericActionModalMessage('Escribe aquí un mensaje')
                            setGenericActionModalButton(
                              <>
                                <button
                                  className="btn btn-danger px-3 py-2 me-2"
                                  type="button"
                                  onClick={async () => {
                                    handleApplicationAfterDraftReject()
                                    setShowGenericActionModal(false)
                                  }}
                                >
                                  Enviar motivo de RECHAZO
                                </button>
                              </>
                            )
                            setShowGenericActionModal(true)
                          }}
                        >
                          Rechazar
                        </button>
                        <button
                          className="btn btn-success px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            handleApplicationAfterDraftApprove()
                          }}
                        >
                          Aprobar
                        </button>
                      </div>
                    }
                    {
                      readOnly
                      && formUserId
                      && itemData.applicationStatusDraft === 'Enviada'
                      && itemData.applicationStatusAfterDraft === 'Aprobada'
                      && itemData.applicationStatusPreselection === 'En revisión'
                      &&
                      <div className="d-flex justify-content-start">
                        <button
                          className="btn btn-danger px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            setGenericActionModalTitle('Escribe un mensaje')
                            setGenericActionModalMessage('Escribe aquí un mensaje')
                            setGenericActionModalButton(
                              <>
                                <button
                                  className="btn btn-danger px-3 py-2 me-2"
                                  type="button"
                                  onClick={async () => {
                                    handleApplicationPreselectionReject()
                                    setShowGenericActionModal(false)
                                  }}
                                >
                                  Enviar motivo de RECHAZO
                                </button>
                              </>
                            )
                            setShowGenericActionModal(true)

                          }}
                        >
                          Rechazar
                        </button>
                        <button
                          className="btn btn-success px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            handleApplicationPreselectionApprove()
                          }}
                        >
                          Aprobar
                        </button>
                      </div>
                    }
                    {
                      readOnly
                      && formUserId
                      && itemData.applicationStatusDraft === 'Enviada'
                      && itemData.applicationStatusAfterDraft === 'Aprobada'
                      && itemData.applicationStatusPreselection === 'Seleccionada'
                      && itemData.applicationStatusFinalist === 'En revisión'
                      &&
                      <div className="d-flex justify-content-start">
                        <button
                          className="btn btn-danger px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            setGenericActionModalTitle('Escribe un mensaje')
                            setGenericActionModalMessage('Escribe aquí un mensaje')
                            setGenericActionModalButton(
                              <>
                                <button
                                  className="btn btn-danger px-3 py-2 me-2"
                                  type="button"
                                  onClick={async () => {
                                    handleApplicationFinalistReject()
                                    setShowGenericActionModal(false)
                                  }}
                                >
                                  Enviar motivo de RECHAZO
                                </button>
                              </>
                            )
                            setShowGenericActionModal(true)

                          }}
                        >
                          Rechazar
                        </button>
                        <button
                          className="btn btn-success px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            handleApplicationFinalistApprove()
                          }}
                        >
                          Aprobar
                        </button>
                      </div>
                    }
                    {
                      readOnly
                      && formUserId
                      && credentials.role_id < 3
                      && itemData.applicationStatusDraft === 'Enviada'
                      && itemData.applicationStatusAfterDraft === 'Aprobada'
                      && itemData.applicationStatusPreselection === 'Seleccionada'
                      && itemData.applicationStatusFinalist === 'Seleccionada'
                      && itemData.applicationStatusFinal === 'No destacada'
                      &&
                      <div className="d-flex justify-content-start">
                        <button
                          className="btn btn-primary px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            handleApplicationFinalFeature()
                          }}
                        >
                          Declarar práctica destacada
                        </button>
                        <button
                          className="btn btn-success px-3 py-2 me-2"
                          type="button"
                          onClick={() => {
                            handleApplicationFinalWinner()
                          }}
                        >
                          Declarar práctica ganadora
                        </button>
                      </div>
                    }
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ModalComponent
        id='saveModal'
        title={saveModalTitle}
        show={showSaveModal}
        setShow={setShowSaveModal}
      >
        <div className='d-flex justify-content-between mt-4'>
          <p>
            La postulación ha sido guardada con éxito.
          </p>
        </div>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowSaveModal(false)
            }}
          >
            Continuar
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='saveAndSendModal'
        title={saveAndSendModalTitle}
        show={showSaveAndSendModal}
        setShow={setShowSaveAndSendModal}
        callbackOnHide={handleCallbackOnHide}
        callbackData={callbackData}
      >
        <div className='d-flex justify-content-between mt-4'>
          <p>
            La postulación ha sido guardada con éxito.
          </p>
        </div>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowSaveAndSendModal(false)
            }}
          >
            Continuar
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='genericModal'
        title={genericModalTitle}
        show={showGenericModal}
        setShow={setShowGenericModal}
        callbackOnHide={handleCallbackOnHide}
        callbackData={callbackData}
      >
        <div className='d-flex justify-content-between mt-4'>
          <p>
            {genericModalMessage}
          </p>
        </div>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowGenericModal(false)
            }}
          >
            Continuar
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='genericActionModal'
        title={genericActionModalTitle}
        show={showGenericActionModal}
        setShow={setShowGenericActionModal}
      >
        <div className='d-flex justify-content-between mt-4'>
          <textarea
            className='form-control'
            rows='3'
            placeholder={genericActionModalMessage}
            ref={textareaRef}
          ></textarea>
        </div>
        <div className='d-flex justify-content-between mt-4'>
          {genericActionModalButton}
        </div>
      </ModalComponent>
      <ModalComponent
        id='preOperationModal'
        title={preOperationModalTitle}
        show={showPreOperationModal}
        setShow={setShowPreOperationModal}
        headerClass='bg-primary text-white'
        modalSize='modal-lg'
      >
        <p>{preOperationModalMessage}</p>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowPreOperationModal(false)
            }}
          >
            No
          </button>
          <button
            type='button'
            className='btn btn-outline-primary'
            onClick={() => {
              setShowPreOperationModal(false)
              handleFormSaveAndSend()
            }}
          >
            Sí
          </button>
        </div>
      </ModalComponent>
    </>
  )
}
